import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

// module
import { NgModule } from '@angular/core';
import { BrowserModule, provideClientHydration, withNoHttpTransferCache } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FIREBASE_OPTIONS } from '@angular/fire/compat';
import { AppRoutingModule } from './app-routing.module';
import { MatDialogModule } from '@angular/material/dialog';
import { AppTradeSmartLoginModule } from '@shared/module/dialog/trade-smart/trade-smart.module';
import { AlertMessageModule } from './shared-module/alert-message/alert-message.module';

// component
import { AppComponent } from './app.component';
import { AppPageNotFoundComponent } from './page-not-found/page-not-found.component';
// services
import { InterceptorService } from './services/http-interceptor.service';
import { FireBaseService } from './services/firebase.service';
import { UserTrackingService } from '@angular/fire/compat/analytics';

import { WindowRef } from './services/shared.service';
import { environment } from 'src/environments/environment';
import { MixPanelService } from '@service/mix-panel.service';
import { FinvasiaModule } from './shared-module/dialog/finvasia/finvasia.module';
import { ReferralRewardModule } from './shared-module/referral-reward/referral-reward.module';
import { SplashScreenModule } from './splash-screen/splash-screen.module';
import { ClaimRewardModule } from './shared-module/dialog/claim-reward/claim-reward.module';
import { ReferTransactionModule } from './shared-module/dialog/refer-transaction/refer-transaction.module';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { getAnalytics, provideAnalytics, ScreenTrackingService as ScreenTrackingService_alias } from '@angular/fire/analytics';
import { getFunctions, provideFunctions } from '@angular/fire/functions';
import { getMessaging, provideMessaging } from '@angular/fire/messaging';
import { provideCacheableAnimationLoader, provideLottieOptions } from 'ngx-lottie';
import { GoogleTagManagerModule } from 'angular-google-tag-manager';
import { PixelModule } from 'ngx-multi-pixel';
import { AppLoaderModule } from './shared-module/app-loader/app-loader.module';
@NgModule({
  declarations: [
    AppComponent,
    AppPageNotFoundComponent,
  ],
  imports: [
    HttpClientModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    MatDialogModule,
    AppTradeSmartLoginModule,
    AlertMessageModule,
    FinvasiaModule,
    ReferralRewardModule,
    SplashScreenModule,
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAnalytics(() => getAnalytics()),
    provideFunctions(() => getFunctions()),
    provideMessaging(() => getMessaging()),
    ClaimRewardModule,
    ReferTransactionModule,
    GoogleTagManagerModule.forRoot({
      id: environment.GTM_ID
    }),
    PixelModule.forRoot({ enabled: true, pixelId: [environment.FBPixelAppId] }),
    AppLoaderModule
  ],
  providers: [
    { provide: FIREBASE_OPTIONS, useValue: environment.firebase },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true,
    },
    FireBaseService,
    WindowRef,
    MixPanelService,
    provideClientHydration(
      withNoHttpTransferCache()
    ),
    ScreenTrackingService_alias,
    UserTrackingService,
    provideLottieOptions({
      player: () => import('lottie-web'),
    }),
    provideCacheableAnimationLoader(),
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
